import React from 'react'
import { useAuth } from '../contexts/AuthContext'
import { useNavigate } from 'react-router-dom'
import { Clock } from 'lucide-react'
import { useLocale } from '../contexts/LocaleContext'

const PendingApprovalPage: React.FC = () => {
  const { t } = useLocale()
  const { signOut, volunteerRequest } = useAuth()
  const navigate = useNavigate()

  const handleSignOut = async () => {
    console.log('Sign out button clicked')
    try {
      console.log('Calling signOut...')
      await signOut()
      console.log('Sign out completed successfully')
      // Redirect to login page after successful sign out
      navigate('/login')
    } catch (error) {
      console.error('Error signing out:', error)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 text-center">
        <div className="mx-auto h-12 w-12 flex items-center justify-center rounded-full bg-yellow-100">
          <Clock className="h-6 w-6 text-yellow-600" />
        </div>
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
          {t('pendingApproval.title')}
        </h2>
        <div className="space-y-4">
          <p className="text-center text-sm text-gray-600">
            {t('pendingApproval.message')}
          </p>
          {volunteerRequest?.requested_at && (
            <p className="text-xs text-gray-500">
              Aanmelding ingediend op {new Date(volunteerRequest.requested_at).toLocaleDateString()}
            </p>
          )}
          <p className="text-sm text-gray-600">
            {t('pendingApproval.checkEmail')}
          </p>
        </div>
        <div className="space-y-3">
          <div className="bg-blue-50 rounded-lg p-4 text-left">
            <h3 className="text-sm font-medium text-blue-800 mb-2">Wat gebeurt er nu?</h3>
            <ul className="text-xs text-blue-700 space-y-1">
              <li>• Ons team beoordeelt je aanmelding</li>
              <li>• Je ontvangt een e-mail met de beslissing</li>
              <li>• Bij goedkeuring krijg je toegang tot het vrijwilligersportaal</li>
            </ul>
          </div>
          <button
            onClick={handleSignOut}
            className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            {t('pendingApproval.signOut')}
          </button>
        </div>
      </div>
    </div>
  )
}

export default PendingApprovalPage